const r = {
  "radius-25": "0.125rem",
  "radius-50": "0.25rem",
  "radius-75": "0.375rem",
  "radius-100": "0.5rem",
  "radius-125": "0.625rem",
  "radius-150": "0.75rem",
  "radius-200": "1rem",
  "radius-300": "1.5rem",
  "radius-400": "62.5rem"
};
export {
  r as radii
};
//# sourceMappingURL=radii.es.js.map
